import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

export const BaseLayout = styled(Vertical).attrs({ center: true, gap: 2 })``;

export const CardsArea = styled.div`
  width: 100%;
  max-width: 320px;
  --pack-max-width: 320px;
  --stripe-height: 50px;
  --pack-aspect-ratio: 0.65217;
`;
